import { useDispatch } from 'react-redux'
import { CustomUploadProfilePic } from '../../../../Core/CustomUploadProfilePic'
import styles from '../../../Style'
import { Text } from 'react-native-web'
import Icons from '../../../../Constants/Icons'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../../../Config/Actions/loadingActions'
import Colors from '../../../../Constants/Colors'
import { useFormContext } from '../FormProvider'

const EventTicketStub = () => {
  const { formData, setFormData, errors } = useFormContext()
  const dispatch = useDispatch()
  const handleImageUpload = async event => {
    dispatch(setLoadingTrue())
    const selectedImage = event.target.files[0]
    if (!selectedImage) return

    const uploadData = new FormData()
    uploadData.append('imageURL', selectedImage)
    uploadData.append('imageType', 'EventTicketImages')
    uploadData.append('imageStoreId', '123456789')

    try {
      const data = await CustomUploadProfilePic(uploadData)
      dispatch(setLoadingFalse())
      if (data && data.status === true) {
        setFormData(prevForm => ({
          ...prevForm,
          TicketImages: data.location
        }))
      } else {
        console.warn('Image upload failed.')
      }
    } catch (error) {
      dispatch(setLoadingFalse())
      console.error('Error uploading profile picture:', error)
    }
  }

  const handleImageDelete = () => {
    setFormData(prevForm => ({
      ...prevForm,
      TicketImages: ''
    }))
  }
  const handleImageUploadEvent = async event => {
    dispatch(setLoadingTrue())
    const selectedImages = event.target.files
    const newImagesArray = []

    try {
      const maxImages = 4
      if (formData.EventPoster.length + selectedImages.length > maxImages) {
        console.warn('Cannot add more than 4 images.')
        return
      }

      for (let i = 0; i < selectedImages.length; i++) {
        const formDataUpload = new FormData()
        const selectedImage = selectedImages[i]
        formDataUpload.append('imageURL', selectedImage)
        formDataUpload.append('imageType', 'EventTicketImages')
        formDataUpload.append('imageStoreId', '123456789')

        try {
          const data = await CustomUploadProfilePic(formDataUpload)
          dispatch(setLoadingFalse())
          if (data && data.status === true) {
            newImagesArray.push(data.location)
          }
        } catch (error) {
          dispatch(setLoadingFalse())
          console.error('Error uploading profile picture:', error)
        }
      }

      if (formData.EventPoster.length + newImagesArray.length > maxImages) {
        console.warn('Cannot add more than 4 images.')
        return
      }

      setFormData(prevForm => ({
        ...prevForm,
        EventPoster: [...prevForm.EventPoster, ...newImagesArray]
      }))
    } catch (error) {
      dispatch(setLoadingFalse())
      console.error('Error handling images:', error)
    }
  }
  const uploadImageRemove = index => {
    setFormData(prevForm => ({
      ...prevForm,
      EventPoster: prevForm.EventPoster.filter((_, i) => i !== index)
    }))
  }

  return (
    <div>
      <div>
        <Text style={styles.labelPhoto}>Event Ticket Stub</Text>
      </div>
      <div style={{ fontSize: '11px', marginTop: '10px' }}>
        Click The + Button To Customize And Change The <br /> Event Ticket
        Background
      </div>
      <div style={{ marginBottom: '20px' }}>
        <div
          className={`Category_upload ${
            errors.TicketImages ? 'invalid' : 'valid'
          }`}
          style={{
            backgroundColor: Colors.dark_black,
            height: '70px',
            width: '80px',
            borderRadius: '15px',
            cursor: 'pointer'
          }}
        >
          <div className='absolute'>
            <div
              className='upload-data'
              style={{ width: '40px', height: '40px' }}
            >
              <input
                type='file'
                style={{ height: '40px', width: '40px', cursor: 'pointer' }}
                onChange={handleImageUpload}
                accept='image/*'
              />
              <img
                src={Icons.Ic_AddedImg}
                style={{ height: '40px', width: '40px' }}
                alt='Upload Icon'
              />
            </div>
          </div>
        </div>

        {formData.TicketImages && (
          <div
            className='w-full text-center '
            style={{ width: '500px', position: 'relative' }}
          >
            <img
              src={Icons.delete}
              alt='Delete'
              onClick={handleImageDelete}
              className='delete'
              style={{
                position: 'absolute',
                width: '20px',
                cursor: 'pointer',
                height: '20px',
                objectFit: 'cover',
                filter: 'brightness(0) invert(1)',
                right: '-15px',
                top: '-15px'
              }}
            />
            <img
              src={formData.TicketImages}
              alt='Event Ticket Preview'
              style={{ width: '500px', height: '155px', objectFit: 'contain' }}
              className='m-auto'
            />
          </div>
        )}

        <div
          style={{
            marginLeft: '30px',
            marginTop: '20px',
            marginBottom: '40px'
          }}
        >
          <Text style={styles.labelPhoto}>Provide A Quick Preview Of What The Audience Can Expect At Your Event.</Text>
          <div className='expect_event'>
            <div>
              <input
                value={formData.Expect}
                className={`${errors.Expect ? 'invalid' : 'valid'}`}
                placeholder='Good Vibes'
                onChange={e =>
                  setFormData(prevForm => ({
                    ...prevForm,
                    Expect: e.target.value
                  }))
                }
                type='text'
              />
            </div>
            <div>
              <input
                value={formData.Expect1}
                className={`${errors.Expect1 ? 'invalid' : 'valid'}`}
                placeholder='Delicious Bites & Drinks'
                onChange={e =>
                  setFormData(prevForm => ({
                    ...prevForm,
                    Expect1: e.target.value
                  }))
                }
                type='text'
              />
            </div>
            <div>
              <input
                value={formData.Expect2}
                placeholder='Immersive Art Experience'
                className={`${errors.Expect2 ? 'invalid' : 'valid'}`}
                onChange={e =>
                  setFormData(prevForm => ({
                    ...prevForm,
                    Expect2: e.target.value
                  }))
                }
                type='text'
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className={`Category_upload ${
          errors.EventPoster ? 'invalid' : 'valid'
        }`}
        style={{
          backgroundColor: Colors.dark_black,
          height: '100px',
          width: '100%',
          borderRadius: '15px',
          marginBottom: '30px'
        }}
      >
        <div
          className='absolute'
          style={{
            justifyContent: 'flex-start',
            marginLeft: '20px',
            display: 'block',
            marginTop: '20px'
          }}
        >
          <Text style={[{ marginBottom: '50px' }, styles.labelPhoto]}>
            Event Poster
          </Text>

          <div
            style={{
              display: 'flex',
              gap: '20px',
              marginTop: '15px'
            }}
          >
            <div
              className='upload-data'
              style={{
                width: '40px',
                height: '40px',
                cursor: 'pointer'
              }}
            >
              <input
                type='file'
                style={{
                  height: '40px',
                  width: '40px',
                  cursor: 'pointer'
                }}
                onChange={handleImageUploadEvent}
                accept='image/*'
              />
              <img
                src={Icons.Ic_AddedImg}
                style={{ height: '40px', width: '40px' }}
              />
            </div>
            {formData.EventPoster?.map((imageData, index) => (
              <div key={index.toString()} style={{ position: 'relative' }}>
                <img
                  src={imageData}
                  alt={`Uploaded preview ${index + 1}`}
                  style={{
                    width: '40px',
                    height: '40px',
                    objectFit: 'cover'
                  }}
                  className='m-auto'
                />
                <img
                  src={Icons.delete}
                  alt='Category Preview'
                  onClick={() => uploadImageRemove(index)}
                  className='delete'
                  style={{
                    position: 'absolute',
                    width: '20px',
                    cursor: 'pointer',
                    height: '20px',
                    right: '-15px',
                    top: '-10px'
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default EventTicketStub
